import { render, staticRenderFns } from "./ModalCancelInsurance.vue?vue&type=template&id=9067970c"
import script from "./ModalCancelInsurance.vue?vue&type=script&lang=js"
export * from "./ModalCancelInsurance.vue?vue&type=script&lang=js"
import style0 from "./ModalCancelInsurance.vue?vue&type=style&index=0&id=9067970c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports